import { FC } from 'react';

import { css, styled } from '@mui/material';
import { components, IndicatorsContainerProps } from 'react-select';

import { ChevronDownIcon } from './chevron-down-icon';
import { LanguageOption } from './locale-picker.types';

export const LocalePickerIndicatorsContainer: FC<
  IndicatorsContainerProps<LanguageOption, false>
> = (props) => {
  const { selectProps } = props;
  const { menuIsOpen } = selectProps;

  return (
    <components.IndicatorsContainer {...props}>
      <StyledChevronDownIcon isActive={menuIsOpen} />
    </components.IndicatorsContainer>
  );
};

const StyledChevronDownIcon = styled(ChevronDownIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive: boolean }>(
  ({ isActive, theme }) => css`
    color: ${isActive ? theme.palette.primary.main : theme.palette.text.primary};
  `
);
